import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import AdminAuthService from '../services/adminAuthService';
import { canAccess } from '../utils/adminPermissions';

/**
 * Wraps a route element and only renders it if the current admin has access to the section.
 * Redirects to /dashboard if not permitted.
 */
const PermittedRoute = ({ section, children }) => {
  const [allowed, setAllowed] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const check = async () => {
      try {
        const role = await AdminAuthService.getAdminRole();
        setAllowed(canAccess(role, section));
      } catch {
        setAllowed(false);
      }
    };
    check();
  }, [section]);

  if (allowed === null) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 120,
        color: '#667085',
        fontSize: 14,
      }}
      >
        Checking access...
      </div>
    );
  }

  if (!allowed) {
    return (
      <Navigate
        to="/dashboard"
        state={{ message: 'You do not have permission to access this section.' }}
        replace
      />
    );
  }

  return children;
};

export default PermittedRoute;
